import React, { Component } from 'react';
import {Button,InputGroup,Input,InputGroupAddon,Modal,ModalBody} from 'reactstrap';
import WarningMessage from '../../Message/WarningMessage/WarningMessage'
import { connect } from 'react-redux';
import * as url from '../../../utils/url';
import axios from '../../../axios';
import Loading from '../../../hoc/Loading/Loading';
import { getFlatDataFromTree,changeNodeAtPath,getNodeAtPath } from 'react-sortable-tree';
import Select from 'react-select';
import find from 'lodash/find';



class OfficeItems extends Component {

  constructor(props) {
    super(props);
    this.state = {
        isNameEdit:false,
        newName:'',
        officeName:this.props.item,
        officeError:"",
        isChanged:false
    }
  }


  changeName = (value) => {
    // const { value } = target;
    let {newName, officeName}=this.state
    // console.log(value)

    if(value){
        this.setState(prevState=>({ 
            newName: value
        }))
        this.props.changeNewOffice(value, 'add', officeName.name)
    } else {
        this.setState(prevState=>({ 
            newName: ''
        }))
        this.props.changeNewOffice(newName, 'remove', officeName.name)

    }
    
  }

formatNewPath= (path, name)=>{
   let p1 =  path.split("#")
    p1 = p1.pop()
    p1.push(name)
    let p2 = p1.join("#")
    return p2
}  

saveNameChanges = () =>{
    // const {item}=this.props
    const {newName, officeName}=this.state
    this.setState({officeError:""})
    if(newName!=="" && officeName.name !== newName.label){
        const {organizationId} = this.props.user.profile;
        let {staticHierarchy} = organizationId;
        // let {savedChanges}=this.state 
        const flat = getFlatDataFromTree({treeData : staticHierarchy,getNodeKey: ({ node }) => 
        node.id,ignoreCollapsed: false } );
        const allOfficePaths = flat.map((p) => {
          const o = {};
          o.path = p.path.join('#');
          o.name = p.node.title;
          return o;
        });
    
    
        const map = find(allOfficePaths,{name: officeName.name});
        let path = map.path.split("#")
    
        let origNode = getNodeAtPath({treeData : staticHierarchy, path:path, getNodeKey: ({ node }) => 
        node.id, ignoreCollapsed: false})
    
        let archivedName = {
                date: Date.now(),
                title: officeName.name,
            }

            
        // let archivedArr 
        console.log(map, origNode)

        let nodeObj = {
            newName: newName.label, 
            title: newName.label, 
            oldTitle: officeName.name,
            newOfficePath: map.newOfficePath? this.formatNewPath(map.newOfficePath, newName.label):null, 
            officeNameArr: [{...staticHierarchy.officeNameArr, ...archivedName}]
        }
    
    
        let nodeChange = changeNodeAtPath({treeData : staticHierarchy, path:path, newNode:{...origNode.node,...nodeObj}, getNodeKey: ({ node }) => 
        node.id,ignoreCollapsed: false})
    
        this.setState({officeName: {name: newName.label}, isChanged:true })

        // Save Hierarchy in database

        console.log(origNode,'--s--',staticHierarchy, '--m--',nodeChange)

        // this.props.saveNewHierarchy(nodeChange)
        axios.post(url.hierarchyNameChange, nodeChange)

        
    } else {
        if(newName===""){
            this.setState({officeError:"Please select an office name"})
        }
        if (officeName.name === newName.label){
            this.setState({officeError:"Office has already been updated"})
        }
    }
   

  }

  officeCss = () => {
    const{isNameEdit, isChanged}=this.state
    let css=''
 
    if (isChanged && isNameEdit){
        css = 'officeItemsFitChanged officeItemsFit'
    } else if(isNameEdit){
        css = 'officeItemsFit'
    } else if (isChanged){
        css='officeItemsFitChanged officeItems inlineBlock'
    }else {
        css='officeItems inlineBlock'
    }
    return css
  }
  

  render() { 

    const {newOffices, newOfficesFound}=this.props
    const{isNameEdit,newName, officeName, officeError}=this.state

    let availableOffices = newOfficesFound.filter(e=> {
        if(e.selected && e.selected==="true"){
            return e
        }
        if(!e.selected) {
            return e
        }
    })
   
    return ( 
        // <div className={isNameEdit?"officeItemsFit": "officeItems"} >
        <div className={this.officeCss()} >

      <div className="officeHierachy" >
        <span onClick={()=>this.setState( prevState=> ({isNameEdit: !prevState.isNameEdit}))}>
            {officeName.name}
        </span>
        {isNameEdit?
            <div>
                   <Select
                    // className="map-table-dropdown"
                    value={newName!==""?newName:""}
                    options={availableOffices && availableOffices.length>0? availableOffices :null}
                    onChange={(value) => this.changeName(value)}
                    clearable={true}
                    // clearable={mapType.uploadEmployeeDataCsv ? true : false}
                      // multi={allowDropdownMultiselect}
                    // multi={multiBool || (values&&values.length)>1?true:false}
                  />
            <div onClick={this.saveNameChanges} className="saveOfficeName"> 
                Save Changes 
            </div>

            {officeError!==""?
            <p className="newOfficeError">
                {officeError}
            </p>
            :
            null
            }

            </div>
         :
        null
        }
      </div>
    
        </div>

    );
  }
}
 

const mapStateToProps = (state) => {
    return {
      user : state.user,

    }
  }
   
export default connect(mapStateToProps)(Loading(OfficeItems,axios));
  
